/* Phase 4 §4 — single import site for the bridge schema.
 *
 * The `Command`/`Event` types are generated by `tsify-next` into the
 * `engine-wasm` wasm-pack package (the `bridge` crate is not built
 * standalone). Re-exporting them here keeps the deep `../../../crates/...`
 * relative path in one place — UI code imports from `../engine/types`. */
export type {
    A11yCell,
    A11yNode,
    A11yParagraph,
    A11yPatch,
    A11yRow,
    A11yRun,
    A11yTable,
    A11yTextBox,
    A11yNote,
    A11yNoteKind,
    A11yNoteRef,
    A11yObjectKind,
    A11yObjectRef,
    A11yTree,
    Alignment,
    AttrsMixed,
    FormattingToggle,
    BlockPath,
    BridgeBorderStroke,
    BridgeBorderStyle,
    BridgeCellBorders,
    BridgeStoryRef,
    HeaderFooterArea,
    ClientCapabilities,
    Color,
    Command,
    Direction,
    DocFormat,
    EngineCapabilities,
    EngineStats,
    Event,
    FontMetrics,
    ErrorKind,
    ImageBlob,
    ImageFit,
    ImageWrapMode,
    TextBoxHop,
    LogicalPos,
    LogicalRange,
    MoveDirection,
    ParagraphId,
    PathStep,
    PdfConformance,
    Point,
    Rect,
    ReadWarning,
    ReadWarningKind,
    SaveNote,
    SaveNoteKind,
    Script,
    SelectionKind,
    SelectionModifier,
    TextAttrs,
    TextAttrsPatch,
    UnderlineStyle,
    VerticalScript,
} from '../../../crates/engine-wasm/pkg/engine_wasm.js';
import type { BlockPath, LogicalPos } from '../../../crates/engine-wasm/pkg/engine_wasm.js';

/** Path to the Nth top-level block — `BlockPath::top(n)` mirror. */
export function topBlockPath(idx: number): BlockPath {
    return { steps: [{ kind: 'BLOCK', idx }] };
}

/** Caret at offset `n` of the Nth top-level paragraph. */
export function topPos(para: number, offset: number): LogicalPos {
    return { path: topBlockPath(para), offset };
}
